export const CATEGORIES = {
  BLOG: {
    label: 'Blog',
    backgroundColor: '#4CAF50',
    color: 'white'
  },
  NEWS: {
    label: 'Berita',
    backgroundColor: '#2196F3',
    color: 'white'
  },
  ANNOUNCEMENT: {
    label: 'Pengumuman',
    backgroundColor: '#FFC107',
    color: 'black'
  },
  ACHIEVEMENT: {
    label: 'Prestasi',
    backgroundColor: '#F44336',
    color: 'white'
  }
};

export const getCategoryStyles = (category) => {
  if (!category) return { backgroundColor: '#ddd', color: '#333' };
  const cat = CATEGORIES[category.toUpperCase()];
  return {
    backgroundColor: cat?.backgroundColor || '#ddd',
    color: cat?.color || '#333'
  };
};
